export default __webpack_public_path__ + "e60db88aa8a6f1f913bb3f9045ee2ae2.jpg";